import emailjs from "@emailjs/browser";
import React, { useRef, useState } from "react";

export const ContactSection = () => {
  const form = useRef();
  const [alertMessage, setAlertMessage] = useState("");
  const [alertColor, setAlertColor] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_4tciyzz", // Remplacez par votre Service ID
        "template_xzpyqca", // Remplacez par votre Template ID
        form.current,
        "2IaytlSZU4LUjtsuQ" // Remplacez par votre User ID (clé publique)
      )
      .then(
        () => {
          setAlertMessage("Votre message a été envoyé avec succès !");
          setAlertColor("green");
          form.current.reset(); // Réinitialise le formulaire après envoi
        },
        (error) => {
          setAlertMessage(
            "Erreur lors de l'envoi du message. Veuillez réessayer."
          );
          setAlertColor("red");
        }
      );
  };

  return (
    <section
      className="contact section-padding"
      style={{
        backgroundImage: `url('img/contact.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-5 mb-60 animate-box" data-aos="fade-right">
            <h5>Informations</h5>

            <div className="contact-link">
              <div className="contact-link-icon">
                <img src="img/icons/c1.svg" alt="Icône téléphone" />
              </div>
              <div className="contact-link-content">
                <div className="contact-link-title">Appelez-nous</div>
                <div className="contact-link-text">
                  <a
                    href="tel:0649735256"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    06.49.73.52.56
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-link">
              <div className="contact-link-icon">
                <img src="img/icons/c2.svg" alt="Icône email" />
              </div>
              <div className="contact-link-content">
                <div className="contact-link-title">Envoyez-nous un email</div>
                <div className="contact-link-text">
                  <a
                    href="mailto:contact.jacobproduction@gmail.com"
                    style={{ color: "#fff", textDecoration: "none", fontSize: "14px"  }}
                  >
                    contact.jacobproduction@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-link">
              <div className="contact-link-icon">
                <img src="img/icons/c3.svg" alt="Icône localisation" />
              </div>
              <div className="contact-link-content">
                <div className="contact-link-title">Visitez notre bureau</div>
                <div className="contact-link-text text-white">
                  33 rue Vineuse 75116, Paris
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-md-5 offset-md-2 animate-box"
            data-aos="fade-left"
          >
            <div className="form-box">
              <h5>Contactez-nous</h5>

              {/* Message d'alerte */}
              {alertMessage && (
                <div style={{ color: alertColor, marginBottom: "20px" }}>
                  {alertMessage}
                </div>
              )}

              <form ref={form} onSubmit={sendEmail} className="contact__form">
                <div className="row">
                  <div className="col-md-12 form-group">
                    <input
                      name="from_name"
                      type="text"
                      placeholder="Votre Nom *"
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      name="from_email"
                      type="email"
                      placeholder="Votre Email *"
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      name="from_phone"
                      type="text"
                      placeholder="Votre Numéro *"
                      required
                    />
                  </div>
                  <div className="col-md-12 form-group">
                    <input
                      name="from_subject"
                      type="text"
                      placeholder="Sujet *"
                      required
                    />
                  </div>
                  <div className="col-md-12 form-group">
                    <textarea
                      name="message"
                      id="message"
                      cols="30"
                      rows="4"
                      placeholder="Message *"
                      required
                    ></textarea>
                  </div>
                  <div className="col-md-12" style={{ marginTop: "20px" }}>
                    <input type="submit" value="Envoyer le message" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
